/**
 * @generated SignedSource<<bfdd2e33d14830a3c3f4ed25610a03cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleShareWidgetArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"articleCommentsTriggerArticle" | "contentShareWidgetContent">;
  readonly " $fragmentType": "articleShareWidgetArticle";
};
export type articleShareWidgetArticle$key = {
  readonly " $data"?: articleShareWidgetArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleShareWidgetArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleShareWidgetArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentShareWidgetContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleCommentsTriggerArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "1df5138be6baaebae2067419754b3b5b";

export default node;
